import styled from 'styled-components'

export const FiltersSection = styled.div`
  margin: 24px 0;

  .filters-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 24px;
    flex-wrap: wrap;
  }

  .filter-buttons {
    display: flex;
    gap: 0;

    button {
      padding: 10px 16px;
      font-size: 14px;
      min-width: auto;
      white-space: nowrap;
      border-radius: 0;

      &:first-child {
        border-radius: 8px 0 0 8px;
      }

      &:last-child {
        border-radius: 0 8px 8px 0;
      }

      &:not(:last-child) {
        border-right: none;
      }
    }
  }

  .search-section {
    display: flex;
    gap: 8px;
    align-items: center;
    flex: 1;
    max-width: 400px;

    input {
      flex: 1;
    }

    button {
      padding: 10px 16px;
      font-size: 14px;
      min-width: auto;
      white-space: nowrap;
    }
  }
`

export const StatusBadge = styled.div<{ color: string }>`
  background: ${(props) => props.color}20;
  color: ${(props) => props.color};
  padding: 4px 12px;
  border-radius: 16px;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  display: inline-block;
`

export const TypeBadge = styled.div<{ color: string }>`
  background: ${(props) => props.color}15;
  color: ${(props) => props.color};
  padding: 4px 12px;
  border-radius: 16px;
  font-size: 12px;
  font-weight: 600;
  display: inline-block;
`

export const LoadingWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 400px;
  color: #666;
`

export const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 400px;
  text-align: center;

  h3 {
    margin-bottom: 8px;
    color: #333;
  }

  p {
    color: #666;
    margin-bottom: 24px;
  }
`

export const ErrorState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 400px;
  text-align: center;

  h3 {
    margin-bottom: 8px;
    color: #ff4444;
  }

  p {
    color: #666;
    margin-bottom: 24px;
  }
`

export const TableWrapper = styled.div`
  background: white;
  border-radius: 8px;
  overflow: hidden;
  margin-top: 24px;
`

export const ActionsCell = styled.div`
  display: flex;
  gap: 8px;
  justify-content: flex-end;
`
